// extracted by mini-css-extract-plugin
module.exports = {"bottomNavigation":"styles_bottomNavigation__pq08v","root":"styles_root__30SrH"};